import styled, { css } from 'styled-components';
import { TBluredWrapperProps } from './types';

export const BluredWrapper = styled.span<TBluredWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;

  ${({ $blurContent }) =>
    $blurContent &&
    css`
      filter: blur(3px);
    `}
`;
